import { observable, action } from 'mobx';
// import { paperCheckHistoryData } from 'Components/PaperCheck/MockData';
import { CHECK_ENGINE_TYPE, CHECK_ERROR_TYPE, CHECK_STATUS_TYPE, AVAILABLE_STATUS, APP_STORE_PAPER_CHECK_STATUS_TYPE, CHECK_STEPS_MAP, CHECK_TIMEOUT_TIME, PARTNER_CODE_MAP } from '@/components/PaperCheck/contant';
import { otelApi, paymentApi, wanFangPaperCheckApi } from '@/api';
import { formatPaperCheckOrderData, mySetInterval, formatPriceDetail } from 'Components/PaperCheck/utils'
import { base64ToBlob } from '@/utils/utils';

export default class PaperCheckStore {
	@observable isShowPaperCheckDialog = false;
	@observable currentCheckInfo = null;
	@observable paperCheckCurrentStep = CHECK_STEPS_MAP.Setting;
	@observable isShowPaperCheckHistoryDialog = false;
	@observable isShowPaperCheckResultDialog = false;
	@observable paperCheckHistoryList = [];
	@observable isInitPaperCheckHistoryList = false;
	@observable paperCheckQueryTaskMessage = null;
	@observable showPaperCheckDialog = null;
	@observable showPaperCheckNoticeInfoDialog = null;
	@observable showPaperCheckMessageDialog = null;
	@observable showPaperCheckResultNoticeMessage = null;
	@observable showPaperCheckResultDialog = null;
	@observable popupPaymentPopup = false;
	@observable queryTaskList = [];
	@action resetCurrentCheckInfo() {
		this.currentCheckInfo = null;
	}
	@action updateCurrentCheckInfo(currentCheckInfo = {}) {
		this.currentCheckInfo = { ...this.currentCheckInfo, ...currentCheckInfo };
	}
	@action updatePaperCheckCurrentStep(step) {
		this.paperCheckCurrentStep = step;
	}
	@action updatePaperCheckHistoryList(listInfo, waiting_payList = []) {
		let _list = [...this.paperCheckHistoryList];
		let list = [];
		if (Array.isArray(listInfo)) {
			list = [...listInfo];
		} else if (listInfo && typeof listInfo === 'object') {
			list = [listInfo];
		} else {
			list = [];
		}
		list.forEach(paperCheckDetail => {
			let index = _list.findIndex(_item =>  _item.orderId === paperCheckDetail.orderId);
			if (index > -1) {
				_list[index] = { ..._list[index], ...paperCheckDetail };
			} else {
				_list.push(paperCheckDetail);
			}
		})
		// 过滤掉不在 请求回来的 waiting_payList 列表里面的 waiting_pay 记录
		let waiting_payListOderIds = waiting_payList.map(item => item.orderId);
		_list = _list.filter(item => ![APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_WAITING_PAY].includes(item.checkStatus) || waiting_payListOderIds.includes(item.orderId));
		
		this.paperCheckHistoryList = _list;
	}
	@action updateIsShowPaperCheckDialog(visible) {
		this.isShowPaperCheckDialog = visible;
	}
	@action updateIsShowPaperCheckResultDialog(visible) {
		this.isShowPaperCheckResultDialog = visible;
	}
	@action setShowPaperCheckHistoryDialog(visible) {
		this.isShowPaperCheckHistoryDialog = visible;
	}
	@action updatePopupPaymentPopup(visible) {
		this.popupPaymentPopup = visible;
	}
	@action setPaperCheckNoticeMessage(msg) {
		this.paperCheckNoticeMessage = msg;
	}
	@action setPaperCheckQueryTaskMessage(msg) {
		this.paperCheckQueryTaskMessage = msg;
	}
	@action setShowPaperCheckDialogMethod(method) {
		this.showPaperCheckDialog = method;
	}
	@action setShowPaperCheckNoticeInfoDialog(method) {
		this.showPaperCheckNoticeInfoDialog = method;
	}
	@action setShowPaperCheckMessageDialog(method) {
		this.showPaperCheckMessageDialog = method;
	}
	@action setShowPaperCheckResultNoticeMessage(method) {
		this.showPaperCheckResultNoticeMessage = method;
	}
	@action setShowPaperCheckResultDialogMethod(method) {
		this.showPaperCheckResultDialog = method;
	}
	@action queryPaperCheckHistoryList() {
		return paymentApi.getPaperCheckOrders().then(res => {
			if (res.data && res.data.list && res.data.list.length) {
				let _paperCheckHistoryList = res.data.list.map(item => formatPaperCheckOrderData(item));
				let availableList = _paperCheckHistoryList.filter(item => Object.values(AVAILABLE_STATUS).includes(item.checkStatus));
				let waiting_payList = availableList.filter(item => [APP_STORE_PAPER_CHECK_STATUS_TYPE.STATUS_WAITING_PAY].includes(item.checkStatus));
				let fn = (waiting_payListDetail) => {
					if (waiting_payListDetail) {
						waiting_payListDetail.forEach(waiting_payListItem => {
							let _index = availableList.findIndex(item => item.orderId === waiting_payListItem.orderId);
							if (_index > -1) {
								availableList[_index] = { ...availableList[_index], ...waiting_payListItem };
							}
						})
					}
					if (!this.isInitPaperCheckHistoryList) {
						this.isInitPaperCheckHistoryList = true;
						this.paperCheckHistoryList = [...availableList];
						let checkingList = this.paperCheckHistoryList.filter(item => item.checkStatus === CHECK_STATUS_TYPE.Checking);
						if (checkingList.length) {
							checkingList.forEach(({ orderId, checkId, checkEngine, checkStartTime }) => {
								this.doPaperCheckQueryTask(orderId, checkId, checkEngine, checkStartTime)
							})
						}
					} else {
						this.updatePaperCheckHistoryList([...availableList], waiting_payListDetail);
					}
					return Promise.resolve();
				}
				if (waiting_payList.length) {
					let promises = [...waiting_payList.map(item => this.getPaperCheckOrderDetail(item.orderId))];
					return Promise.all(promises).then((waiting_payListDetail) => {
						fn(waiting_payListDetail)
					}, err => {
						return Promise.reject(err);
					});
				} else {
					return fn();
				}
			} else {
				return Promise.resolve();
			}
		}, err => {
			return Promise.reject(err);
		})
	}
	@action getPaperCheckEngineInfo() {
		return paymentApi.getPaperPrices().then(res => {
			if (res.data) {
				let wangFangPriceInfo = res.data.filter(item => item.partner_code === PARTNER_CODE_MAP[CHECK_ENGINE_TYPE.WangFang]);
				if (wangFangPriceInfo.length) {
					let { price_detail, logo_url } = wangFangPriceInfo[0];
					// return new Promise( (resolve) => {
					// 	setTimeout(() => {
					// 		resolve({
					// 			[CHECK_ENGINE_TYPE.WangFang]: {
					// 				price_detail: formatPriceDetail(price_detail),
					// 				logo: logo_url.icon
					// 			}
					// 		})
					// 	}, 10000)
					// })
					return Promise.resolve({
						[CHECK_ENGINE_TYPE.WangFang]: {
							price_detail: formatPriceDetail(price_detail),
							logo: logo_url.icon
						}
					})
				}
			}
			return Promise.resolve();
		}, err => {
			return Promise.reject(err);
		})
	}
	@action createPaperCheckOrder(formData, sign) {
		return paymentApi.createPaperCheckOrder(formData, sign);
	}
	@action getPaperCheckOrderDetail(orderId) {
		return paymentApi.getPaperCheckOrderDetail(orderId).then(
			res => Promise.resolve(formatPaperCheckOrderData(res.data)),
			err => Promise.reject(err)
		);
	}
	@action updatePaperCheckId(orderId, checkId) {
		return paymentApi.updatePaperCheckId(orderId, checkId).then(
			res => Promise.resolve(res),
			err => Promise.reject(err)
		);
	}
	@action updatePaperCheckErrorType(orderId, checkErrorType) {
		return paymentApi.updatePaperCheckErrorType(orderId, checkErrorType).then(
			res => Promise.resolve(res),
			err => Promise.reject(err)
		);
	}
	@action updatePaperCheckCopyPercent(orderId, checkTotalCopyPercent) {
		return paymentApi.updatePaperCheckCopyPercent(orderId, checkTotalCopyPercent).then(
			res => Promise.resolve(res),
			err => Promise.reject(err)
		);
	}
	@action getPaperCheckPaymentInfo(orderId) {
		return paymentApi.getPaperCheckPaymentInfo(orderId);
	}
	@action textExtract(checkEngine, { file, fileName }) {
		if (checkEngine === CHECK_ENGINE_TYPE.WangFang) {
			return wanFangPaperCheckApi.textExtractV2(file, fileName);
		}
		return Promise.resolve();
	}
	@action doPaperCheck(checkEngine, params) {
		if (checkEngine === CHECK_ENGINE_TYPE.WangFang) {
			return wanFangPaperCheckApi.doDbCheck(params);
		}
		return Promise.resolve();
	}
	@action doPaperCheckQueryTask(orderId, checkId, checkEngine, checkStartTime) {
		if (checkEngine === CHECK_ENGINE_TYPE.WangFang) {
			let queryTaskJob = mySetInterval(this.doWFPaperCheckQuery.bind(this, orderId, checkId, checkEngine, checkStartTime), 2000)
			let task = {
				checkId,
				clearInterval: queryTaskJob,
				start: this.doWFPaperCheckQuery.bind(this, orderId, checkId, checkEngine, checkStartTime)
			}
			this.queryTaskList.push(task);
			task.start(); // 默认执行一次
		}
	}
	@action doPaperCheckQueryApi(checkEngine, checkId) {
		if (checkEngine === CHECK_ENGINE_TYPE.WangFang) {
			return wanFangPaperCheckApi.dbCheckQuery(checkId);
		}
		return Promise.resolve();
	}
	@action doWFPaperCheckQuery(orderId, checkId, checkEngine, checkStartTime) {
		let isCurrentCheckQuery = this.currentCheckInfo && this.currentCheckInfo.checkId === checkId;
		if (this.isCheckTimeout(checkStartTime)) {
			this.updatePaperOderInfo({
				orderId,
				checkTotalCopyPercent: 0,
				checkStatus: CHECK_STATUS_TYPE.Error,
				checkErrorType: CHECK_ERROR_TYPE.Timeout,
				isCurrentCheckQuery
			});
			this.stopQueryTaskJob(checkId);
			return Promise.resolve()
		}
		return this.doPaperCheckQueryApi(checkEngine, checkId).then(
			res => {
				if (res.response.data) {
					let { copyPercent, checkStatus } = res.response.data;
					let _checkTotalCopyPercent = copyPercent * 100;
					if (checkStatus === CHECK_STATUS_TYPE.Success || checkStatus === CHECK_STATUS_TYPE.Error) {
						this.stopQueryTaskJob(checkId);
						this.updatePaperOderInfo({
							orderId,
							checkTotalCopyPercent: _checkTotalCopyPercent,
							checkStatus,
							checkErrorType: CHECK_ERROR_TYPE.Error,
							isCurrentCheckQuery
						});
					}
				}
			},
			err => {
				console.log(err);
			}
		)
	}
	@action checkResultPdfReport(checkEngine, checkId, checkTitle, success, error) {
		if (checkEngine === CHECK_ENGINE_TYPE.WangFang) {
			return wanFangPaperCheckApi.checkResultPdfReport(checkId).then(
				(res) => {
					let { data } = res.response;
					let base64 = `data:application/pdf;base64,${data}`;
					let blob = base64ToBlob(base64);
					let fileName = `${checkTitle}（原文标注报告）.pdf`
					let pdfReport = new File([blob], fileName, { type: 'application/pdf' })
					success && success(pdfReport)
					return Promise.resolve(pdfReport);
				},
				(err) => {
					error && error(err);
					return Promise.reject(err);
				}
			)
		}
		return Promise.resolve();
	}
	@action checkResultZip(checkEngine, checkId, checkTitle) {
		if (checkEngine === CHECK_ENGINE_TYPE.WangFang) {
			return wanFangPaperCheckApi.checkResultZip(checkId).then(
				(res) => Promise.resolve(new File([res.data], `${checkTitle}.zip`, { type: 'application/zip' })),
				(err) => Promise.reject(err)
			)
		}
		return Promise.resolve();
	}
	isCheckTimeout(checkStartTime) {
		let isTimeout = false;
		let _checkStartTime = new Date(checkStartTime);
		if (_checkStartTime instanceof Date && !isNaN(_checkStartTime.getTime())) {
			if (Date.now() - _checkStartTime.getTime() >= CHECK_TIMEOUT_TIME) {
				isTimeout = true;
			}
		}
		return isTimeout;
	}
	stopQueryTaskJob(checkId) {
		let index = this.queryTaskList.findIndex(item => item.checkId === checkId);
		if (index > -1) {
			let queryTaskJob = this.queryTaskList[index];
			queryTaskJob.clearInterval(true);
			this.queryTaskList.splice(index, 1);
		}
	}
	updatePaperOderInfo({ orderId, checkTotalCopyPercent, checkStatus, checkErrorType, isCurrentCheckQuery }) {
		const showFn = () => {
			if (isCurrentCheckQuery) {
				if (this.isShowPaperCheckDialog) {
					if (isCurrentCheckQuery && this.paperCheckCurrentStep === CHECK_STEPS_MAP.Finish) {
						// 关闭查重界面
						this.isShowPaperCheckDialog = false;
						// 弹 结果窗口
						this.showPaperCheckResultDialog(orderId);
					}
				} else if (!this.isShowPaperCheckHistoryDialog && !this.isShowPaperCheckResultDialog) {
					// 弹 右上角 notice 窗
					let message = {
						statusType: checkStatus,
						itemId: orderId
					}
					this.showPaperCheckResultNoticeMessage(message);
				}
			}
		}

		let _updateInfo;

		// 更新 appStore订单信息（ checkTotalCopyPercent, checkStatus, checkErrorType） 使用 orderId
		if (checkStatus === CHECK_STATUS_TYPE.Success) {
			_updateInfo = {
				orderId,
				checkStatus,
				checkTotalCopyPercent
			}
			this.updatePaperCheckCopyPercent(orderId, checkTotalCopyPercent).then(res => {
				if (res.code === 200 && res.msg.toLowerCase() === 'success') {
					showFn();
				}
			})
		}
		if (checkStatus === CHECK_STATUS_TYPE.Error) {
			_updateInfo = {
				orderId,
				checkStatus,
				checkErrorType
			}
			this.updatePaperCheckErrorType(orderId, checkErrorType).then(res => {
				if (res.code === 200 && res.msg.toLowerCase() === 'success') {
					showFn();
				}
			});
		}
		if (_updateInfo) {
			// 更新 CurrentCheckInfo和paperHistory信息，列表信息（ checkStatus, checkErrorType checkTotalCopyPercent使用 orderId
			if (isCurrentCheckQuery) {
				this.updateCurrentCheckInfo({
					..._updateInfo
				})
			}
			this.updatePaperCheckHistoryList({
				..._updateInfo
			});
		}
	}
	@action sendJaegerData({ action, label, jaegerCategory = 'PChecker_Event' }) {
		otelApi.sendJaegerData({ spanName: action, operationName: action, extraInformation: '', category: jaegerCategory, label: label })
	}
}


